<template>
  <div class="ownerFamilyByLift">
    <div class="titleWrap">
      <div class="setTitle">乘梯记录</div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/owner' }">业主列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ownerDetail?ownerId=' + ownerId + '&ownerRoomId=' + ownerRoomId + '&ownerName=' + encodeURI(encodeURI(ownerName)) + '&villageId=' + villageId + '&roomId=' + roomId }">{{ familyName }}</el-breadcrumb-item>
        <el-breadcrumb-item>乘梯记录</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button class="myBtn" type="primary" plain size="small" @click="exportByLift">导出</el-button>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-table :data="byLiftAttr" class="list">
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="building" label="楼栋" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.building }}栋
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单元" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.unit }}单元
          </template>
        </el-table-column>
        <el-table-column prop="room" label="房号" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.room) }}
          </template>
        </el-table-column>
        <el-table-column prop="passType" label="乘梯方式" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ passType(scope.row.passType) }}
          </template>
        </el-table-column>
        <el-table-column prop="passNumber" label="乘梯码" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="passTime" label="乘梯时间" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ passTime(scope.row.passTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="userType" label="用户类型" min-width="180" :align="align">
          <template slot-scope="scope">
            <div class="userType owner" v-if="scope.row.userType === 0 || scope.row.userType === 1"></div>
            <div class="userType family" v-if="scope.row.userType === 2"></div>
            <div class="userType tenant" v-if="scope.row.userType === 3"></div>
            <div class="userType property" v-if="scope.row.userType === 4"></div>
            <div class="userType visitor" v-if="scope.row.userType === 5"></div>
            {{ userType(scope.row.userType) }}
          </template>
        </el-table-column>
        <el-table-column prop="passager" label="乘梯人姓名" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="result" label="刷卡结果" min-width="180" :align="align">
          <template slot-scope="scope">
            <div class="cardResult open" v-if="scope.row.result"></div>
            <div class="cardResult close" v-else></div>
            {{ resultInt(scope.row.result) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="byLiftCurr" :page-sizes="[10, 20, 50]" :page-size="byLiftSize" :total="byLiftTotal" @current-change="byLiftCurrChange" @size-change="byLiftSizeChange"></el-pagination>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'OwnerFamilyByLift',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      villageId: '', // 小区Id
      roomId: '', // 房间Id
      ownerId: '', // 业主Id
      ownerName: '', // 业主姓名
      ownerRoomId: '', // 业主房间Id
      familyId: '', // 家人Id
      familyName: '', // 家人姓名
      byLiftAttr: [], // 乘梯记录列表
      byLiftTotal: 0, // 乘梯记录总数
      byLiftSize: 10, // 乘梯记录每页条数
      byLiftCurr: 1 // 乘梯记录当前页数
    }
  },
  mounted () {
    // 小区Id
    this.villageId = this.$route.query.villageId
    // 房间Id
    this.roomId = this.$route.query.roomId
    // 业主Id
    this.ownerId = this.$route.query.ownerId
    // 业主房间Id
    this.ownerRoomId = this.$route.query.ownerRoomId
    // 业主姓名
    this.ownerName = decodeURI(decodeURI(this.$route.query.ownerName))
    // 家人Id
    this.familyId = this.$route.query.familyId
    // 家人姓名
    this.familyName = decodeURI(decodeURI(this.$route.query.familyName))

    this.getByLiftList(this.byLiftCurr, this.byLiftSize)
  },
  methods: {
    getByLiftList (page, size) {
      this.$http.get(this.$api.by_lift_list, {
        params: {
          pageNum: page,
          pageSize: size,
          ownerId: this.familyId,
          roomId: this.roomId,
          orgId: this.villageId
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.byLiftAttr = data.data.list
          this.byLiftTotal = data.data.total
          this.byLiftSize = size
          this.byLiftCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getByLiftList(1, this.byLiftSize)
    },
    exportByLift () {
      window.open(this.$url + this.$api.by_lift_export + '?orgId=' + this.villageId + '&ownerId=' + this.familyId + '&roomId=' + this.roomId)
    },
    byLiftCurrChange (curr) {
      this.getByLiftList(curr, this.byLiftSize)
    },
    byLiftSizeChange (size) {
      this.getByLiftList(this.byLiftCurr, size)
    },
    passType (val) {
      switch (val) {
        case 0:
          return 'IC卡'
        case 1:
          return '二维码'
        case 2:
          return '蓝牙'
        case 3:
          return '人脸'
      }
    },
    userType (val) {
      switch (val) {
        case 0:
          return '普通业主'
        case 1:
          return '业主代表'
        case 2:
          return '家人'
        case 3:
          return '租户'
        case 4:
          return '物业保洁'
        case 5:
          return '访客'
      }
    },
    resultInt (val) {
      if (val) {
        return '成功'
      } else {
        return '失败'
      }
    },
    passTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2) + ' ' + time.substr(11, 2) + ':' + time.substr(14, 2) + ':' + time.substr(17, 2)
      }
    },
    notData (str) {
      return this.$null(str)
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.byLiftCurr - 1) * this.byLiftSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.ownerFamilyByLift
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
    .el-breadcrumb
      float left
      margin-left 20px
      height 32px
      line-height 32px
      font-size 12px
    .myBtn
      float right
  .tableWrap
    margin-top 20px
    padding-top 12px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .input
      float left
      margin-top 8px
      margin-left 20px
      width 160px
    .time
      float left
      margin-top 8px
      margin-left 20px
    .searchBtn
      float left
      margin-top 8px
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      &>>>thead
        tr, th
          color #666
          background-color #fafafa
          .cell
            font-weight bold
      &>>>tbody
        tr, th
          color #333
      &>>>td
        padding 7px 0
      &>>>.cell
        line-height 34px
        .userType
          display inline-block
          width 16px
          height 16px
          background-repeat no-repeat
          background-size 100% 100%
          vertical-align sub
          &.owner
            background-image url('./owner.png')
          &.family
            background-image url('./family.png')
          &.tenant
            background-image url('./tenant.png')
          &.property
            background-image url('./property.png')
          &.visitor
            background-image url('./visitor.png')
        .cardResult
          display inline-block
          width 10px
          height 10px
          border-radius 50%
          &.open
            background-color #60ACFC
          &.close
            background-color #ccc
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
</style>



// WEBPACK FOOTER //
// src/components/user/ownerFamilyByLift.vue